import { Avatar } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { APP_NAME, menuItems } from "../../constants";
import logo from "../../assets/ledgerflow-logo-icon.png";
import { getAvatarGradientStyle, getInitials } from "../../utils/avatar";
import { getOptionLabel } from "../../utils/i18n";

const nextThemeMode = (mode) => {
  if (mode === "auto") return "light";
  if (mode === "light") return "dark";
  return "auto";
};

export default function Shell({
  activeView,
  children,
  currentUser,
  drawerCollapsed,
  effectiveTheme,
  locale,
  onLogout,
  onInstallApp,
  onThemeModeChange,
  onToggleDrawer,
  onViewChange,
  themeMode,
  t = {}
}) {
  const userIdentity = currentUser.fullName || currentUser.email || "User";
  const userInitials = getInitials(userIdentity);
  const avatarStyle = getAvatarGradientStyle(userIdentity);
  const activeMenuItem = menuItems.find((item) => item.id === activeView) || menuItems[0];
  const activeTitle = getOptionLabel(locale, "menu", activeMenuItem.id, activeMenuItem.text);
  const themeLabel = getOptionLabel(locale, "themeModes", themeMode, themeMode === "auto" ? "Auto" : themeMode === "dark" ? "Dark" : "Light");
  const themeIcon = themeMode === "auto" ? "gear" : effectiveTheme === "dark" ? "sun" : "moon";

  return (
    <div className="app-frame">
      <aside className={`app-sidebar ${drawerCollapsed ? "is-collapsed" : ""}`}>
        <div className="sidebar-brand">
          <img className="brand-logo" src={logo} alt={`${APP_NAME} logo`} />
          {!drawerCollapsed && (
            <div>
              <strong>{APP_NAME}</strong>
              <span>{t.expenseCommandCenter || "Expense command center"}</span>
            </div>
          )}
        </div>

        <nav className="sidebar-nav" aria-label={t.mainNavigation || "Main navigation"}>
          {menuItems.map((item) => {
            const text = getOptionLabel(locale, "menu", item.id, item.text);

            return (
              <button
                key={item.id}
                className={`sidebar-link ${activeView === item.id ? "is-active" : ""}`}
                onClick={() => onViewChange(item.id)}
                title={text}
                type="button"
              >
                <span className={`k-icon ${item.icon}`} aria-hidden="true" />
                {!drawerCollapsed && <span>{text}</span>}
              </button>
            );
          })}
        </nav>
      </aside>

      <div className="app-main">
        <header className="topbar">
          <div className="topbar-left">
            <Button fillMode="flat" icon="menu" onClick={onToggleDrawer} title={t.toggleNavigation || "Toggle navigation"} />
            <div>
              <p className="eyebrow">{t.personalFinance || "Personal finance"}</p>
              <h1>{activeTitle}</h1>
            </div>
          </div>

          <div className="topbar-actions">
            {onInstallApp && (
              <Button fillMode="outline" icon="download" onClick={onInstallApp}>
                {t.installApp || "Install app"}
              </Button>
            )}
            <Button
              fillMode="flat"
              icon={themeIcon}
              onClick={() => onThemeModeChange(nextThemeMode(themeMode))}
              title={t.themeMode || "Theme mode"}
            >
              {themeLabel}
            </Button>
            <button className="user-chip user-chip-button" onClick={() => onViewChange("profile")} type="button">
              <Avatar
                type={currentUser.avatarDataUrl ? "image" : "text"}
                shape="circle"
                className="user-avatar gradient-avatar"
                style={avatarStyle}
              >
                {currentUser.avatarDataUrl ? <img alt="" src={currentUser.avatarDataUrl} /> : userInitials}
              </Avatar>
              <span>{currentUser.fullName || currentUser.email}</span>
            </button>
            <Button themeColor="error" fillMode="flat" icon="logout" onClick={onLogout}>
              {t.logout || "Logout"}
            </Button>
          </div>
        </header>

        <section className="content-shell">{children}</section>
      </div>
    </div>
  );
}
